import script from "./DiagnosticReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiagnosticReport.vue?vue&type=script&lang=ts&setup=true"

import "./DiagnosticReport.vue?vue&type=style&index=0&id=b4709986&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4709986"]])

export default __exports__